import React from 'react';

import Number from './Number';

/**
 * Currency field input.
 * @param {string} [label] Label description for field input.
 * @param {number} [initialValue] Current field value.
 * @param {function} [handleSave] [async number=>{bool success, string message}] Save changes / return error message.
 */
const Currency = ({ label, initialValue, handleSave: syncChanges }) => {
    return <Number {...{ label, initialValue, handleSave: syncChanges, isCurrency: true }} />;
};

export default Currency;
